// Typelizer digest d9969c069ffd2196d2091e25cdac5df5
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../../runtime'
import { buildUrl } from '../../runtime'

export default {
  /** GET /educators/team_applications/:team_application_id/response/accept */
  accept: (
    params: { teamApplicationId: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'get'> => ({
    url: buildUrl('/educators/team_applications/:team_application_id/response/accept', params, options),
    method: 'get',
  }),

  /** GET /educators/team_applications/:team_application_id/response/reject */
  reject: (
    params: { teamApplicationId: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'get'> => ({
    url: buildUrl('/educators/team_applications/:team_application_id/response/reject', params, options),
    method: 'get',
  }),

  /** GET /educators/team_applications/:team_application_id/response/new */
  new: (
    params: { teamApplicationId: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'get'> => ({
    url: buildUrl('/educators/team_applications/:team_application_id/response/new', params, options),
    method: 'get',
  }),

  /** GET /educators/team_applications/:team_application_id/response */
  show: (
    params: { teamApplicationId: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'get'> => ({
    url: buildUrl('/educators/team_applications/:team_application_id/response', params, options),
    method: 'get',
  }),

  /** POST /educators/team_applications/:team_application_id/response */
  create: (
    params: { teamApplicationId: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'post'> => ({
    url: buildUrl('/educators/team_applications/:team_application_id/response', params, options),
    method: 'post',
  }),
}
